import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";
import { useLang } from "@/context/LanguageContext";

export const Journey = () => {
  const { t } = useLang();
  const j = t.journey;
  return (
    <section id="journey" className="py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="overline text-[#C4A484] mb-5">{j.overline}</motion.p>
          <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewport} className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-[#0D2A27]">{j.heading}</motion.h2>
        </div>

        <div className="border-t border-[#E2E0D8]">
          {j.steps.map((step, i) => (
            <motion.div key={step.n} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={viewport} className="group grid md:grid-cols-12 gap-4 md:gap-8 items-baseline border-b border-[#E2E0D8] py-8 md:py-10 transition-colors duration-300 hover:bg-[#EDECE6]/60" data-testid={`journey-step-${step.n}`}>
              <span className="md:col-span-2 font-serif text-5xl md:text-6xl text-[#C4A484] leading-none">{step.n}</span>
              <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl text-[#0D2A27]">{step.title}</h3>
              <p className="md:col-span-6 text-[#555] leading-relaxed">{step.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
